import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { IonContent, MenuController } from '@ionic/angular';
import { NavigateRoutes, RequestType, StorageConstants } from 'common/constants/app.constant';
import { CoBrandingApiQueryParams } from 'common/models/pagemodels/co-branding/co-branding.model';
import { RouteMessage } from 'common/models/utilitymodels/base.model';
import { SideMenuItem, TabInfoModel } from 'common/models/utilitymodels/menu.model';
import { StorageService } from 'common/services/core_services/storage.service';
import { SystemService } from 'common/services/core_services/system.service';

@Component({
    selector: 'bh-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent implements OnChanges, OnInit {
    tabInfo = new TabInfoModel().tabInfo;
    @Input() sideMenuItems: SideMenuItem[];
    @Input() showTabs: boolean = true;
    @ViewChild(IonContent, { static: false }) content: IonContent;

    constructor(private menuCtrl: MenuController, public systemService: SystemService, private router: Router) {}
    highlighMenu: boolean = false;
    ngOnInit(): void {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                const userData = JSON.parse(this.systemService.getLocalStorage(StorageConstants.userProfile));
                this.tabInfo.forEach((tab) => {
                    if (userData && userData.type === 'NON_IFA_USER') {
                        if ([NavigateRoutes.investorList].includes(tab.routeTo)) {
                            tab.show = false;
                        } else {
                            tab.show = true;
                        }
                    }
                    if (userData && userData.type === 'IFA_USER') {
                        if ([NavigateRoutes.prostartVideos].includes(tab.routeTo)) {
                            tab.show = false;
                        } else {
                            tab.show = true;
                        }
                    }
                });
                if (event.url.startsWith('/distributor/transact')) {
                    this.tabInfo[0].selected = true;
                    this.tabInfo[1].selected = false;
                    this.tabInfo[2].selected = false;
                    this.tabInfo[3].selected = false;
                    this.tabInfo[4].selected = false;
                    this.highlighMenu = false;
                } else if (event.url.startsWith('/distributor/investor')) {
                    this.tabInfo[0].selected = false;
                    this.tabInfo[1].selected = false;
                    this.tabInfo[2].selected = false;
                    this.tabInfo[3].selected = true;
                    this.tabInfo[4].selected = false;
                    this.highlighMenu = false;
                } else if (event.url.startsWith('/distributor/prostart')) {
                    this.tabInfo[0].selected = false;
                    this.tabInfo[1].selected = false;
                    this.tabInfo[2].selected = false;
                    this.tabInfo[3].selected = false;
                    this.tabInfo[4].selected = true;
                    this.highlighMenu = false;
                } else if (event.url.startsWith('/distributor/co-branding')) {
                    this.tabInfo[0].selected = false;
                    this.tabInfo[1].selected = false;
                    this.tabInfo[2].selected = true;
                    this.tabInfo[3].selected = false;
                    this.tabInfo[4].selected = false;
                    this.highlighMenu = false;
                } else if (event.url.startsWith('/distributor/dashboard')) {
                    this.tabInfo[0].selected = false;
                    this.tabInfo[1].selected = true;
                    this.tabInfo[2].selected = false;
                    this.tabInfo[3].selected = false;
                    this.tabInfo[4].selected = false;
                    this.highlighMenu = false;
                } else {
                    this.tabInfo[0].selected = false;
                    this.tabInfo[1].selected = false;
                    this.tabInfo[2].selected = false;
                    this.tabInfo[3].selected = false;
                    this.tabInfo[4].selected = false;
                    this.highlighMenu = true;
                }
            }
        });
    }

    toggleMenu() {
        this.content.scrollByPoint(0, 1, 100);
        this.menuCtrl.toggle();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.showTabs = changes['showTabs'].currentValue;
    }

    async navigateTo(item: any) {
        if (!this.systemService.canNavigate) {
            this.systemService.showToaster('You are Offline!', 'error');
            return;
        }
        const routeMessage = new RouteMessage();
        if (item.routeTo === NavigateRoutes.distributordashboard) {
            routeMessage.type = RequestType.ID;
        } else if (item.routeTo === NavigateRoutes.investorList) {
            routeMessage.type = RequestType.GET;
            routeMessage.transferData.curruntActiveList = item.routerData.curruntActiveList;
        } else if (item.routeTo === NavigateRoutes.prostartVideos) {
            routeMessage.type = RequestType.GET;
            item.routerData.apiParams = new CoBrandingApiQueryParams();
            routeMessage.transferData.curruntActiveList = item.routerData.curruntActiveList;
        } else if (item.routeTo === NavigateRoutes.coBranding) {
            routeMessage.type = RequestType.GET;
            item.routerData.apiParams = new CoBrandingApiQueryParams();
            routeMessage.transferData = item;
        } else {
            routeMessage.type = RequestType.BLANK;
        }
        if (!this.systemService.isTransactionRouteForPopup) {
            await this.systemService.storageService.clearStorage();
        }
        this.systemService.setLocalStorage(StorageConstants.curruntActiveTab, '');
        this.systemService.routeByUrl(item.routeTo, routeMessage);
    }
}
